'use client';
import { AccordionDetails } from '@volvo-cars/react-accordion';
import { useTracker } from '@volvo-cars/tracking';
/**
 * Faq component for displaying frequently asked questions.
 *
 * @component
 * @example
 * ```tsx
 * import Faq from './Faq';
 *
 * const App = () => {
 *   return (
 *     <Faq trackEventLabel="FAQ 1">
 *       <Question>Question 1</Question>
 *       <Answer>Answer 1</Answer>
 *     </Faq>
 *   );
 * };
 * ```
 */
import React, { type HTMLAttributes } from 'react';

export type Props = {
  trackEventLabel: string;
  defaultOpen?: boolean;
};

const Faq = ({
  children,
  trackEventLabel,
  defaultOpen,
  ...props
}: Omit<HTMLAttributes<HTMLDetailsElement>, 'onToggle'> & Props) => {
  const tracker = useTracker();

  return (
    <AccordionDetails
      defaultOpen={defaultOpen}
      onToggle={(expanded) => {
        tracker.interaction({
          eventAction: expanded ? 'accordion|expand' : 'accordion|collapse',
          eventLabel: trackEventLabel,
        });
      }}
      {...props}
    >
      {children}
    </AccordionDetails>
  );
};

export default Faq;
